module.exports = __webpack_public_path__ + "img/anxiang.655f32ab.png";